import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "site-footer"
};
const _hoisted_2 = {
  class: "footer-inner footer-main"
};
const _hoisted_3 = {
  class: "footer-brand"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "footer-cta"
};
const _hoisted_6 = {
  class: "footer-qr"
};
const _hoisted_7 = {
  class: "footer-qr__list"
};
const _hoisted_8 = ["aria-label", "onClick"];
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = {
  class: "footer-qr__caption"
};
const _hoisted_11 = {
  class: "footer-inner footer-contact"
};
const _hoisted_12 = ["href"];
const _hoisted_13 = ["href"];
const _hoisted_14 = {
  class: "footer-inner footer-bottom"
};
const _hoisted_15 = {
  class: "footer-legal"
};
const _hoisted_16 = {
  class: "footer-links"
};
const _hoisted_17 = ["aria-label"];
const _hoisted_18 = {
  class: "qr-zoom__card"
};
const _hoisted_19 = ["src", "alt"];
const _hoisted_20 = {
  class: "qr-zoom__caption"
};
const _hoisted_21 = {
  class: "qr-zoom__hint"
};
import { onUnmounted, ref, watch } from 'vue';
import logoMark from '../../assets/imgs/logo.png';
import wechatQr from '../../assets/imgs/fuwuhao.jpg';
import qqQr from '../../assets/imgs/qqqun.jpg';
import iosQr from '../../assets/imgs/app-ios-qr.png';
import androidQr from '../../assets/imgs/app-android-qr.png';
export default {
  __name: 'Footer',
  setup(__props) {
    const company = {
      tel: '051085382052',
      telText: '0510-85382052',
      email: '2759450915@qq.com',
      address: '江苏省无锡市新吴区清源路 20 号立业楼 C 栋二楼 213',
      hours: '工作日 8:00–18:00 '
    };
    const qrCodes = [{
      key: 'wechat',
      src: wechatQr,
      caption: '服务号',
      alt: '微信服务号',
      hint: '微信扫一扫关注，获取产品动态与睡眠指南'
    }, {
      key: 'qq',
      src: qqQr,
      caption: 'QQ群',
      alt: 'QQ 交流群 1042265176',
      hint: 'QQ 扫一扫加群，工程师在线答疑'
    }, {
      key: 'ios',
      src: iosQr,
      caption: 'iOS',
      alt: 'iOS 版 App',
      hint: '用 iPhone 相机扫码前往 App Store'
    }, {
      key: 'android',
      src: androidQr,
      caption: '安卓',
      alt: 'Android 版 App',
      hint: '用浏览器扫码下载安装包'
    }];
    const currentYear = new Date().getFullYear();

    /* ========== 二维码放大 ========== */
    const activeQr = ref(null);
    const openQr = code => {
      activeQr.value = code;
      document.documentElement.classList.add('qr-zoom-open');
    };
    const closeQr = () => {
      activeQr.value = null;
      document.documentElement.classList.remove('qr-zoom-open');
    };
    const onKeydown = event => {
      if (event.key === 'Escape') closeQr();
    };
    watch(activeQr, value => {
      if (value) {
        window.addEventListener('keydown', onKeydown);
      } else {
        window.removeEventListener('keydown', onKeydown);
      }
    });
    const scrollToTop = () => {
      const reduced = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: 0,
        behavior: reduced ? 'auto' : 'smooth'
      });
    };
    onUnmounted(() => {
      window.removeEventListener('keydown', onKeydown);
      document.documentElement.classList.remove('qr-zoom-open');
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
        class: "footer-logo",
        to: "/",
        "aria-label": "返回首页"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: _unref(logoMark),
          alt: "无锡特文思达健康科技有限公司",
          width: "26",
          height: "26"
        }, null, 8, _hoisted_4)]),
        _: 1
      }), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "footer-brand__text"
      }, [_createElementVNode("p", {
        class: "footer-name"
      }, "无锡特文思达健康科技有限公司"), _createElementVNode("p", {
        class: "footer-name-en"
      }, "Wuxi Twin-Star Health Technology Co., Ltd."), _createElementVNode("p", {
        class: "footer-brand__meta"
      }, "脑机交互睡眠健康 · 成立于 2022 年 · 江苏无锡")], -1))]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_router_link, {
        class: "footer-btn footer-btn--primary",
        to: "/contact"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode(" 申请体验 "), _createElementVNode("i", {
          "aria-hidden": "true"
        }, "↗", -1)])),
        _: 1
      }), _createVNode(_component_router_link, {
        class: "footer-btn",
        to: "/contact"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode(" 商务合作 "), _createElementVNode("i", {
          "aria-hidden": "true"
        }, "→", -1)])),
        _: 1
      })]), _createElementVNode("div", _hoisted_6, [_createElementVNode("ul", _hoisted_7, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(qrCodes, code => {
        return _createElementVNode("li", {
          key: code.key
        }, [_createElementVNode("button", {
          type: "button",
          class: "footer-qr__btn",
          "aria-label": `放大查看${code.alt}二维码`,
          onClick: $event => openQr(code)
        }, [_createElementVNode("img", {
          src: code.src,
          alt: `${code.alt}二维码`,
          loading: "lazy"
        }, null, 8, _hoisted_9)], 8, _hoisted_8), _createElementVNode("span", _hoisted_10, _toDisplayString(code.caption), 1)]);
      }), 64))])])]), _createElementVNode("div", _hoisted_11, [_cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "footer-contact__label"
      }, "联系我们", -1)), _createElementVNode("a", {
        href: `tel:${company.tel}`
      }, "电话 " + _toDisplayString(company.telText), 9, _hoisted_12), _cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "footer-divider",
        "aria-hidden": "true"
      }, "·", -1)), _createElementVNode("a", {
        href: `mailto:${company.email}`
      }, "邮箱 " + _toDisplayString(company.email), 9, _hoisted_13), _cache[5] || (_cache[5] = _createElementVNode("span", {
        class: "footer-divider",
        "aria-hidden": "true"
      }, "·", -1)), _createElementVNode("span", null, "地址 " + _toDisplayString(company.address), 1), _cache[6] || (_cache[6] = _createElementVNode("span", {
        class: "footer-divider",
        "aria-hidden": "true"
      }, "·", -1)), _createElementVNode("span", null, "工作时间 " + _toDisplayString(company.hours), 1)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("p", _hoisted_15, [_createElementVNode("span", null, "© 2023–" + _toDisplayString(_unref(currentYear)) + " 无锡特文思达健康科技有限公司", 1), _cache[7] || (_cache[7] = _createElementVNode("span", {
        class: "footer-divider",
        "aria-hidden": "true"
      }, "·", -1)), _cache[8] || (_cache[8] = _createElementVNode("a", {
        href: "https://beian.miit.gov.cn/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, " 苏ICP备2024117755号-3 ", -1))]), _createElementVNode("p", _hoisted_16, [_createVNode(_component_router_link, {
        to: "/privacy"
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("隐私政策")])),
        _: 1
      }), _cache[12] || (_cache[12] = _createElementVNode("span", {
        class: "footer-divider",
        "aria-hidden": "true"
      }, "·", -1)), _createVNode(_component_router_link, {
        to: "/terms"
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("服务条款")])),
        _: 1
      }), _cache[13] || (_cache[13] = _createElementVNode("span", {
        class: "footer-divider",
        "aria-hidden": "true"
      }, "·", -1)), _createElementVNode("button", {
        type: "button",
        class: "footer-top",
        onClick: scrollToTop
      }, _cache[11] || (_cache[11] = [_createTextVNode(" 回到顶部 "), _createElementVNode("i", {
        "aria-hidden": "true"
      }, "↑", -1)]))])]), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [activeQr.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "qr-zoom",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": `${activeQr.value.alt}二维码`,
        onClick: _withModifiers(closeQr, ["self"])
      }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
        src: activeQr.value.src,
        alt: `${activeQr.value.alt}二维码`
      }, null, 8, _hoisted_19), _createElementVNode("p", _hoisted_20, _toDisplayString(activeQr.value.alt), 1), _createElementVNode("p", _hoisted_21, _toDisplayString(activeQr.value.hint), 1), _createElementVNode("button", {
        type: "button",
        class: "qr-zoom__close",
        "aria-label": "关闭",
        onClick: closeQr
      }, "✕")])], 8, _hoisted_17)) : _createCommentVNode("", true)]))]);
    };
  }
};